export const init = () => {
    const observer = new MutationObserver((mutations) => {
        if (document.querySelector('.js-counter')) {
            const counters = document.querySelectorAll('.js-counter:not([data-inicialized])');
            counters.forEach((item) => {
                item.setAttribute('data-inicialized', 'true');
                const elPlus = item.querySelector('.plus');
                const elMinus = item.querySelector('.minus');
                const elInput = item.querySelector('.js-counter-input');

                const minValue = Number(elInput.min);
                const maxValue = Number(elInput.max);
                let countValue = Number(elInput.value);

                elInput.addEventListener('change', function () {
                    if (elInput.value > maxValue) {
                        elInput.value = maxValue;
                        countValue = maxValue;
                    }
                    if (elInput.value < minValue) {
                        elInput.value = minValue;
                        countValue = minValue;
                    }
                })

                elPlus.addEventListener('click', function (e) {
                    e.preventDefault();
                    countValue += 1;
                    elInput.value = countValue;
                    elInput.dispatchEvent(new Event('change', { bubbles: true }))
                });

                elMinus.addEventListener('click', function (e) {
                    e.preventDefault();
                    countValue -= 1;
                    elInput.value = countValue;
                    elInput.dispatchEvent(new Event('change', { bubbles: true }))
                });
            });
        }
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
};